import { render, staticRenderFns } from "./OnlineClassEdit.vue?vue&type=template&id=00e3abb6&scoped=true&"
import script from "./OnlineClassEdit.vue?vue&type=script&lang=js&"
export * from "./OnlineClassEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e3abb6",
  null
  
)

export default component.exports